import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Team = lazy(() => import('./pages/Team'));
const Services = lazy(() => import('./pages/Services'));
const TaxServices = lazy(() => import('./pages/TaxServices'));
const LegalServices = lazy(() => import('./pages/LegalServices'));
const AcademyServices = lazy(() => import('./pages/AcademyServices'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Contact = lazy(() => import('./pages/Contact'));
const FeedbackTax = lazy(() => import('./pages/FeedbackTax'));
const FeedbackLegal = lazy(() => import('./pages/FeedbackLegal'));
const FeedbackAcademy = lazy(() => import('./pages/FeedbackAcademy'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Loading component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-vintage-cream">
    <div className="text-center">
      <div className="relative w-20 h-20 mx-auto mb-4">
        <div className="absolute inset-0 border-4 border-vintage-gold/30 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-vintage-gold border-t-transparent rounded-full animate-spin"></div>
      </div>
      <p className="text-vintage-dark font-semibold text-lg">Loading...</p>
      <p className="text-vintage-muted text-sm mt-2">Please wait</p>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/tax" element={<TaxServices />} />
              <Route path="/services/legal" element={<LegalServices />} />
              <Route path="/services/academy" element={<AcademyServices />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/feedback/tax" element={<FeedbackTax />} />
              <Route path="/feedback/legal" element={<FeedbackLegal />} />
              <Route path="/feedback/academy" element={<FeedbackAcademy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
